<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="situation">
          <div v-for="item in propositions" :key="item.id" class="familyItems">
            <div class="utility">
              <input
                :id="'insurance' + item.proposition_id"
                :name="
                  'widgets[insurance][forLead][' + item.proposition_id + ']'
                "
                type="checkbox"
                :value="item.proposition_id"
                @click="handleSelectedInsurances(item)"
              />
              <label
                :for="'insurance' + item.proposition_id"
                class="familyLabel"
              >
                <img
                  style="max-height: 80px"
                  :width="item.width"
                  v-if="item.icon"
                  :src="getImage('/' + item.icon)"
                  class="insuranceIcon"
                />
                <span>
                  {{ parseJSONSupplierName(item.name, lang) }}
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";

export default {
  name: "InsuranceForLead",
  data() {
    return {
      propositions: []
    };
  },
  computed: {
    ...mapState({
      insuranceSelectionsLead: state => state.forms.insuranceSelectionsLead
    }),
    currentOverview() {
      return this.overview.filter(a => a.group == "insurance")[0];
    }
  },
  methods: {
    ...mapActions({
      getSupplier: "suppliers/getSupplier"
    }),
    ...mapMutations({
      setInsuranceLead: "forms/SET_INSURANCE_LEAD"
    }),
    handleSelectedInsurances(item) {
      this.setInsuranceLead(item.proposition_id);
      this.handleOverview(item);
      this.$forceUpdate();
    },
    handleOverview(item) {
      let overview = this.overview.filter(a => a.group == "insurance")[0];
      if (
        overview.packages.filter(x => x.proposition_id == item.proposition_id)
          .length > 0
      ) {
        overview.packages.map((a, index) => {
          if (a.proposition_id == item.proposition_id) {
            overview.packages.splice(index, 1);
          }
        });
      } else {
        overview.packages.push(item);
      }
    },
    parseJSONSupplierName(text, language) {
      try {
        return JSON.parse(text)[language];
      } catch (e) {
        return text;
      }
    },
    prepareOverview() {
      this.overview.push({
        id: 10,
        product: { nl: "Quickscan verzekeringen", en: "Insurance quickscan" },
        supplier: {
          id: 70,
          proposition: 216,
          name: '{"nl":"Aansprakelijkheid","en":"Liability"}',
          title: "European Insurances"
        },
        duration: "",
        total: 0,
        onetimetotal: 0,
        discount: 0,
        yearly: 0,
        visible: 1,
        rates: [],
        packages: [],
        widgets: [],
        packagestotal: 0,
        group: "insurance",
        details: [
          { id: 216, type: null, restriction_bag: null, speed: 0 },
          { id: 217, type: null, restriction_bag: null, speed: 0 }
        ],
        rules: []
      });
    }
  },
  mounted() {
    this.getSupplier(10).then(res => {
      this.propositions = res.data.data[0].propositions;
    });
    this.prepareOverview();
  }
};
</script>

<style scoped>
@media only screen and (max-width: 600px) {
  .situation {
  }
  .familyImage {
    display: none;
  }
  .familyLabel {
    height: 50px;
  }
  .familySpan {
  }
}

@media only screen and (min-width: 601px) {
  .situation {
    display: flex;
    justify-content: space-between;
  }
  .familyItems {
    flex: 0.18;
  }
  .familyLabel {
    height: 130px;
  }
  .familySpan {
    display: flex;
    align-self: center;
    flex-direction: column;
    margin-top: 40%;
  }
}
</style>
